import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { DialogsService } from 'src/app/services/manage/dialogs/dialogs.service';
import {ProductService} from "../../../../services/api/product/product.service";

@Component({
  selector: 'app-finded-prods-list',
  templateUrl: './finded-prods-list.component.html',
  styleUrls: ['./finded-prods-list.component.css']
})
export class FindedProdsListComponent implements OnInit {

  @Output() openProdDialEvent = new EventEmitter<any>();

  @Input()
  findedProducts: any;
  @Input()
  pointOfsale: any;
  @Input()
  merchantClient$: any;

  default_prod: string = "https://748073e22e8db794416a-cc51ef6b37841580002827d4d94d19b6.ssl.cf3.rackcdn.com/not-found.png";

  constructor(
    public media: MediaObserver,
    public productService: ProductService,
    public myDials: DialogsService
  ) { }

  ngOnInit() {
  }

  /**
   * Selection d'un article en vente
   * @param prod Article selectionné
   */
  openProdDial(prod: any): void {
    this.openProdDialEvent.emit(prod);
  }
}
